import { ProcessingMessageEntity } from "@/entities/cmb/processingMessage/processingMessageEntity";
import { EntityController, IRequest } from "@intasect/platform-core";
import { url_processingMessage } from "@/controllers/cmb/processingMessage/processingMessageUrls";
export class ProcessingMessageController extends EntityController<ProcessingMessageEntity> {
    constructor(request: IRequest) {
        super(request, url_processingMessage, "消息处理记录");
    }
    static readonly entityName = "processingMessage";
}
